document.addEventListener( 'DOMContentLoaded', function() {
  // Play videos on play button
    document.addEventListener('click', function(e) {
        if ( e.target.matches('a.responsive-video__trigger') || !!e.target.closest('a.responsive-video__trigger') ) {
            e.preventDefault();

            const target = e.target.closest('.responsive-video');
            const trigger = target.querySelector('a.responsive-video__trigger');

            // Fade out trigger
            trigger.classList.add('fade-out');
            
            setTimeout(function() {
                trigger.classList.add('hide');
            }, 300);

            // if the video is an iframe
            if( !!target.querySelector('iframe') ) {
                const iframe = target.querySelector('iframe');
                const src = iframe.getAttribute('src');
                const playSrc = src + '&autoplay=true';
                iframe.setAttribute('src', playSrc);
            } else {
                const video = target.querySelector('video');
                video.play();
            }
        }
    });
});